import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Error404 from './containers/errors/Error404';
// Static Pages
import Home from './containers/pages/Home';

//Policies
import CookiesPolicies from './containers/policies/CookiesPolicies';
import PrivacyPolicies from './containers/policies/PrivacyPolicies';
import FAQs from './containers/policies/FAQs';


function App() {
    return (
            <Router>
                <Routes>
                    {/* Error Display */}
                    <Route path='*' element={<Error404 />} />

                    {/* Static Pages */}
                    <Route exact path='/' element={<Home />} />

                    {/* Policies */}
                    <Route exact path='/cookies-policies' element={<CookiesPolicies />} />
                    <Route exact path='/privacy-policies' element={<PrivacyPolicies />} />
                    <Route exact path='/frecuent-questions' element={<FAQs />} />
                </Routes>
            </Router>
    );
}

export default App;
